import { getMarriageBaselineYShared } from './anchorPoints';
import type { PersonLabelGeometryContext } from '../../../lib/diagram/personLabelBounds';

// Shared utility to compute the exact marriage baseline Y so both the
// marriage renderer and any dependent connectors (e.g., child) use the
// same math, including name label padding for multi‑line names.
export function computeMarriageBaselineY(
  fromNode: any,
  toNode: any,
  getShapeState?: <T extends Record<string, any>>(shapeId: string, baseState: T) => T,
  labelGeometry?: PersonLabelGeometryContext,
): number {
  if (!fromNode || !toNode) return 0;
  return getMarriageBaselineYShared(fromNode, toNode, getShapeState, labelGeometry);
}
